// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_OPEN_CLOSE_LOGIN_MODAL,
} from './constants';

export function openCloseLoginModal(data) {
  return {
    type: COMMON_OPEN_CLOSE_LOGIN_MODAL,
    data:data
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_OPEN_CLOSE_LOGIN_MODAL:
      return {
        ...state,
        showLoginModal:action.data
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/openCloseLoginModal.js